var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-1"},_vm._l((_vm.segments),function(segment,index){return _c('div',{key:index,staticClass:"w-6 h-2 rounded overflow-hidden",style:(_vm.getSegmentStyle(index))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }